import { render, staticRenderFns } from "./attribute_list.vue?vue&type=template&id=6b6d7bb0&scoped=true"
import script from "./attribute_list.vue?vue&type=script&lang=js"
export * from "./attribute_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6d7bb0",
  null
  
)

export default component.exports